import { getFunctions, httpsCallable } from "firebase/functions";

// Lazily acquire the functions instance so tests can mock easily.
function fn(name) {
  return httpsCallable(getFunctions(), name);
}

export async function listFiles(folderId) {
  const r = await fn("listFiles")({ folderId });
  return r.data.files;
}

export async function uploadFile(folderId, file) {
  const base64 = await _fileToBase64(file);
  const r = await fn("uploadFile")({
    folderId,
    name: file.name,
    mimeType: file.type || "application/octet-stream",
    base64,
  });
  return r.data.file;
}

export async function renameFile(fileId, newName) {
  await fn("renameFile")({ fileId, newName });
}

export async function moveFile(fileId, newParentId) {
  await fn("moveFile")({ fileId, newParentId });
}

export async function deleteFile(fileId) {
  await fn("deleteFile")({ fileId });
}

export async function createFolder(parentId, name) {
  const r = await fn("createFolder")({ parentId, name });
  return r.data.folder;
}

export async function createDealFolder(dealId) {
  // Coerce to string — deals store `createdat` as a number (Date.now()),
  // but Firestore document paths must be strings. Callers historically
  // pass deal.createdat, so we normalize here at the boundary.
  const r = await fn("createDealFolder")({ dealId: String(dealId) });
  return r.data.folderId;
}

function _fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(reader.error);
    reader.onload = () => {
      // result is "data:<mime>;base64,<payload>"
      const result = reader.result;
      const idx = result.indexOf(",");
      resolve(idx >= 0 ? result.slice(idx + 1) : result);
    };
    reader.readAsDataURL(file);
  });
}
